import { makeStyles, createStyles } from '@material-ui/core';
import Button from 'app/components/Button';
import NasAcademyFlatIcon from 'app/components/icons/NasAcademyFlatIcon';
import React from 'react';
import { desktopMinWidth } from 'utils/windowHelpers';

type MintDetailsProps = {
  textList?: Array<string>;
  ctaText?: string;
  ctaOnClick?: Function;
  title?: string;
  collectionNumber?: string;
  headerText?: string;
  headerSecondaryText?: string;
  isTokenError?: boolean;
  walletAddress?: string;
  studentName?: string;
};

const MintDetails = ({
  textList,
  ctaText,
  ctaOnClick,
  title,
  headerText,
  headerSecondaryText,
  walletAddress,
  studentName,
  isTokenError = false,
}: MintDetailsProps) => {
  const useStyles = makeStyles(() =>
    createStyles({
      root: {
        [desktopMinWidth]: {
          width: 510,
          maxWidth: 510,
        },
      },
      header: {
        marginBottom: 24,
        [desktopMinWidth]: {
          fontSize: 48,
        },
      },
      headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: 8,
      },
      headerPrimary: {
        fontSize: 20,
        fontWeight: 500,
        color: '#f2f2f2',
        margin: 0,
        [desktopMinWidth]: {
          fontSize: 28,
        },
      },
      headerSecondary: {
        fontSize: 14,
        fontWeight: 400,
        color: '#aaa',
        margin: 0,
        [desktopMinWidth]: {
          fontSize: 18,
        },
      },
      underline: {
        height: 1,
        backgroundColor: '#AAAAAA',
      },
      main: {
        marginBottom: 40,
      },
      mainContainer: {},
      mainPrimary: {
        fontSize: 28,
        fontWeight: 500,
        color: '#f2f2f2',
        margin: 0,
        marginBottom: 16,
        [desktopMinWidth]: {
          fontSize: 32,
        },
      },
      mainSecondary: {
        fontSize: 12,
        fontWeight: 400,
        color: '#aaa',
        margin: 0,
        letterSpacing: 0.7,
        textTransform: 'uppercase',
        [desktopMinWidth]: {
          fontSize: 14,
        },
      },
      list: {
        margin: 0,
        padding: 0,
      },
      listItem: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: 12,
        '&:last-child': {
          marginBottom: 0,
        },
      },
      listItemText: {
        fontSize: 16,
        color: '#f2f2f2',
        marginLeft: 8,
        margin: 0,
        flexShrink: 1,
      },
      cta: {
        width: 'fit-content',
        display: 'none',
        [desktopMinWidth]: {
          display: 'block',
        },
      },
      addressDetail: {
        fontSize: 14,
        color: '#aaa',
        margin: '22px 0 0 0',
        lineHeight: 1.6,
      },
      highlight: {
        textDecoration: 'underline',
      },
      ctaDetail: {
        fontSize: 14,
        fontWeight: 400,
        color: '#aaa',
        margin: 0,
        textAlign: 'center',
        marginTop: 8,
      },
      errorImg: {
        borderRadius: 4,
        marginBottom: 8,
        width: '80%',
        height: 28,
        [desktopMinWidth]: {
          width: '100%',
          height: 34,
        },
      },
      academyIcon: {
        flexShrink: 0,
      },
    }),
  );
  const classes = useStyles();

  const renderList = () => {
    return (
      <ul className={classes.list}>
        {textList?.map((text, index) => (
          <li className={classes.listItem} key={index}>
            <div className={classes.academyIcon}>
              <NasAcademyFlatIcon />
            </div>
            <p className={classes.listItemText}>{text}</p>
          </li>
        ))}
      </ul>
    );
  };
  const defaultTitleImg =
    'https://d2oi1rqwb0pj00.cloudfront.net/lesan/nasio/text.png';

  return (
    <div className={classes.root}>
      {!isTokenError ? (
        <>
          <div className={classes.header}>
            <div className={classes.headerContainer}>
              <p className={classes.headerPrimary}>{headerText}</p>
              <p className={classes.headerSecondary}>{headerSecondaryText}</p>
            </div>
            <div className={classes.underline} />
          </div>
          <div className={classes.main}>
            <div className={classes.mainContainer}>
              <p className={classes.mainSecondary}>Course certificate for</p>
              <p className={classes.mainPrimary}>{title}</p>
            </div>
            {!!textList && renderList()}
            <p className={classes.addressDetail}>
              The NFT will be minted and transferred to {studentName} at public
              address <span className={classes.highlight}>{walletAddress}</span>{' '}
              (Do double check!)
            </p>
          </div>
        </>
      ) : (
        <div className={classes.main}>
          <img
            src={defaultTitleImg}
            className={classes.errorImg}
            alt="default title"
          />
          <div>
            <img
              src={defaultTitleImg}
              className={classes.errorImg}
              alt="default title"
            />
          </div>
        </div>
      )}

      <div className={classes.cta}>
        {/*
        @ts-ignore */}
        <Button displayType="primary" onClick={ctaOnClick}>
          {/*
          @ts-ignore */}
          {ctaText}
        </Button>
        <p className={classes.ctaDetail}>We’ll cover the gas fees.</p>
      </div>
    </div>
  );
};

export default MintDetails;
